module.exports = __webpack_public_path__ + "static/media/9.bc4f3c38.jpg";